import React, { useState } from "react";
import Edit_Risk_Opportunities from "./edit_Risk_Opportunities/Edit_Risk_Opportunities";
import Risk_Opportunities_Form from "./risk_Opportunities_Form/Risk_Opportunities_Form";
import Risk_Opportunities_table from "./risk_Opportunities_table/Risk_Opportunities_table";

function Risk_Opportunities() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <Edit_Risk_Opportunities onCancel={() => setIsEdit(false)} />
      ) : (
        <>
          <div className="imperiality_Form_div">
            <Risk_Opportunities_Form />
          </div>

          <div className="imperiality_table_div">
            <Risk_Opportunities_table onEdit={() => setIsEdit(true)} />
          </div>
        </>
      )}
    </section>
  );
}

export default Risk_Opportunities;
